import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class WeatherService {
	constructor(private httpClient: HttpClient) {}

	public show(
		latitude: number,
		longitude: number
	): Observable<IShowResponse> {
		let httpParams = new HttpParams();
		httpParams = httpParams.append('latitude', latitude?.toString());
		httpParams = httpParams.append('longitude', longitude?.toString());
		return this.httpClient.get<IShowResponse>(
			environment.apiUrl + '/weather/show',
			{ params: httpParams }
		);
	}
}

interface IShowResponse {
	condition: {
		text?: string;
		code?: number;
		temperature?: number;
	};
}
